class TrackedPromises extends Map {
  set(key, promise) {
    promise?.finally(() => this.delete(key))?.catch(() => undefined);
    return super.set(key, promise);
  }
}

export const trackedPromises = new TrackedPromises();

export default new Map();
